/**
 * Candidate sidebar progressive disclosure.
 *
 * - If the user has never saved `preferences.hiddenNavSections`, apply essential defaults
 *   (hide secondary sections until they opt in via Profile → Sidebar Navigation).
 * - Explicit `[]` means "show everything" (after "Show all sections" + Save).
 * - Any saved array is respected as-is.
 */
import navigationConfig from '../config/navigation';

/** Always visible — cannot be toggled off in NavPreferences. */
export const PINNED_NAV_SECTIONS = ['Dashboard', 'Account'];

/**
 * Default-visible sections for candidates who have not customized nav.
 * Campus / Marketplace still respect their feature flags in the Sidebar.
 */
export const ESSENTIAL_NAV_SECTIONS = [
  'Dashboard',
  'Practice',
  'Campus',
  'Resume',
  'Marketplace',
  'Account',
];

export function getDefaultHiddenNavSections(
  sectionLabels = navigationConfig.map((g) => g.label)
) {
  return sectionLabels.filter((label) => !ESSENTIAL_NAV_SECTIONS.includes(label));
}

/**
 * @param {object|null|undefined} preferences - user.preferences
 * @returns {string[]} section labels to hide in the sidebar
 */
export function resolveHiddenNavSections(preferences) {
  if (
    preferences &&
    Object.prototype.hasOwnProperty.call(preferences, 'hiddenNavSections')
  ) {
    const saved = preferences.hiddenNavSections;
    return Array.isArray(saved) ? saved : [];
  }
  return getDefaultHiddenNavSections();
}

export function hasExplicitNavPreferences(preferences) {
  return Boolean(
    preferences &&
      Object.prototype.hasOwnProperty.call(preferences, 'hiddenNavSections')
  );
}
